import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Slick from "vue-slick";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueCookie from "vue-cookie";
import Loading from "vue-loading-overlay";
import Toasted from "vue-toasted";
import VueTelInput from "vue-tel-input";
import { GOOGLE_AUTH_CREDENTIALS } from "@/config";

// Plugins
import headMixin from "@/utils/head";
import Mixin from "@/utils/utilMixin";
import CustomMultiselect from "@/plugins/customMultiselect";
import Notifications from "@/plugins/Notifications";
import VueTimer from "@/plugins/VueTimer";
import EmptyState from "@/common/EmptyState";
import EmptyMovieState from "@/common/EmptyMovieState";
import ComponentContentLoader from "@/common/ComponentContentLoader";
import "@/plugins/OutSideClickEvents/clickEvents";

// Filters
import "./filters/filters";
import cookieType from "@/config/cookieType";

// CSS
import "@/assets/css/app.css";
import "@/assets/css/slick.css";
import "@/assets/css/fancybox.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/customized.css";
import "@/assets/css/responsive.css";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// import Animation
import "vue2-animate/dist/vue2-animate.min.css";
import VueLazyload from "vue-lazyload";
import GoogleAuth from "@/config/google_oAuth.js";
// import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: GOOGLE_AUTH_CREDENTIALS,
  scope: "profile email",
  prompt: "select_account"
};
Vue.use(GoogleAuth, gauthOption);
/**
 * USED PLUGINS
 */
Vue.use(VueTelInput);
Vue.use(VueCookie);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(Loading, {
  loader: "bars",
  color: " #e7beb3",
  width: 70,
  zIndex: 1019,
  height: 70,
  backgroundColor: "#000"
});

Vue.use(Toasted, {
  duration: 3000,
  position: "top-center",
  singleton: true
});
Vue.use(Notifications);
// Vue.mixin(headMixin)
Vue.mixin(Mixin);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/img/dummy.png",
  loading: "/static/img/dummy.png",
  attempt: 1
});

Vue.component("custommultiselect", CustomMultiselect);
Vue.component("slick", Slick);
Vue.component("EmptyState", EmptyState);
Vue.component("EmptyMovieState", EmptyMovieState);
Vue.component("ComponentContentLoader", ComponentContentLoader);
Vue.component("countdown", VueTimer);

import "@/permissionControl/permission";

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  mounted() {
    this.$store.dispatch(
      "setUserLoggedStatus",
      Vue.cookie.get(cookieType.MCHASHID) ? true : false
    );
  }
});



// WEBPACK FOOTER //
// ./src/main.js